import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEVICE_BILL_DETAIL',
        create: 'DEVICE_BILL_CREATE',
        update: 'DEVICE_BILL_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var pic = {
        prop: 'pic',
        default: '',
        label: this.$t('pic'),
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-pic-uploader", {
            "model": {
              value: _this.form.model.pic,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pic", $$v);
              }
            }
          });
        }
      };
      var video = {
        prop: 'pic',
        default: '',
        label: this.$t('video'),
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-video-uploader", {
            "model": {
              value: _this.form.model.pic,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pic", $$v);
              }
            }
          });
        }
      };
      var file = {
        prop: 'pic',
        default: '',
        label: this.$t('apk'),
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-file-uploader", {
            "model": {
              value: _this.form.model.pic,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pic", $$v);
              }
            }
          });
        }
      };
      return [{
        prop: 'device_number',
        default: this.device_number,
        label: this.$t('device_number'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.device_number,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'type',
        default: '',
        label: this.$t('type'),
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "bill_type",
              "button": true
            },
            "on": {
              "change": _this.onTypeChange
            },
            "model": {
              value: _this.form.model.type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "type", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(this.form.model.type == 1 ? [pic] : this.form.model.type == 2 ? [video] : this.form.model.type == 3 ? [file] : [pic]), [{
        prop: 'pic',
        default: '',
        label: this.$t('file_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.pic,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pic", $$v);
              }
            }
          });
        }
      }]);
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    device_number: function device_number() {
      return this.$route.query.device_number;
    }
  },
  methods: {
    onTypeChange: function onTypeChange() {
      this.modelReload({
        pick: ['device_number', 'type', 'pic']
      });
    }
  }
};